import api from '../callApi';

const createCompleteQuizRequest = (answerId, answerText, actionCompletedTime) => {
    return {
        answerId,
        text: answerText,
        actionCompletedTime
    };
};

const completeQuiz = (apiRequestData, answerId, answerText, actionCompletedTime) => {
    const request = {
        ...createCompleteQuizRequest(answerId, answerText, actionCompletedTime),
        ...apiRequestData
    };

    return api.post('Widget/CompleteQuizAsync', request).then(response => {
        return response;
    });
};

export default completeQuiz;
